import api from '@/api'

const store = {
  state: {
    dataGlobal: [],
    pagingGlobal: {
      page: 1,
      size: 20,
      total: 0
    },
    sortingGlobal: {
      byField: '',
      isDesc: false
    },
    filteringGlobal: {
      cond: null,
      code: null,
      description: null
    }
  },

  mutations: {
    SET_GLOBAL: (state, payload) => {
      state.dataGlobal = payload
    },
    SET_PAGING_PAGE_GLOBAL: (state, payload) => {
      state.pagingGlobal.page = payload
    },
    SET_PAGING_TOTAL_GLOBAL: (state, payload) => {
      state.pagingGlobal.total = payload
    },
    SET_SORTING_GLOBAL: (state, payload) => {
      state.sortingGlobal = payload
    },
    SET_FILTERING_GLOBAL: (state, payload) => {
      state.filteringGlobal = payload
    }
  },

  getters: {
    SortingGlobal: state => state.sortingGlobal,
    FilteringGlobal: state => state.filteringGlobal,
    PagingGlobal: state => state.pagingGlobal,
    GetAllGlobal: state => state.dataGlobal,
    GetOneGlobal: state => id =>
      state.dataGlobal.find(dataGlobal => dataGlobal.id === id)
  },

  actions: {
    async UpdateSortingGlobal({ commit, dispatch }, payload) {
      commit('SET_SORTING_GLOBAL', {
        byField: payload.byField,
        isDesc: payload.isDesc
      })
      dispatch('GetAllGlobal')
    },

    async UpdateFilteringGlobal({ commit, dispatch }, isResetField) {
      if (isResetField) {
        const emptyFilter = {
          cond: null,
          code: null,
          description: null
        }
        commit('SET_FILTERING_GLOBAL', emptyFilter)
      }
      commit('SET_PAGING_PAGE_GLOBAL', 1)
      dispatch('GetAllGlobal')
    },

    async GetAllGlobal({ commit, state }) {
      try {
        commit('SET_IS_FETCHING_DATA', true)
        const result = await api.GetAllGlobal(
          state.pagingGlobal,
          state.sortingGlobal,
          state.filteringGlobal
        )
        commit('SET_IS_FETCHING_DATA', false)
        commit('SET_PAGING_TOTAL_GLOBAL', result.headers['data-length'])
        commit('SET_GLOBAL', result.data.data)
        return result.data
      } catch (e) {
        commit('SET_IS_FETCHING_DATA', false)
        throw e
      }
    },

    async CreateGlobal({ dispatch }, payload) {
      try {
        const { data } = await api.CreateGlobal(payload)
        dispatch('GetAllGlobal')
        return data
      } catch (e) {
        return e.response
      }
    },

    async UpdateGlobal({ dispatch }, payload) {
      try {
        const { data } = await api.UpdateGlobal(payload.id, payload)
        dispatch('GetAllGlobal')
        return data
      } catch (e) {
        return e.response
      }
    },

    async DeleteGlobal({ dispatch }, id) {
      try {
        const { data } = await api.DeleteGlobal(id)
        dispatch('GetAllGlobal')
        return data
      } catch (e) {
        return e.response
      }
    }
  }
}

export default store
